import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tip.less';

class Tip extends Component {
    render() {
        return (
            <div className="ir-cck-tip">
                <h4>{this.props.title}</h4>
                <div className="content">{this.props.children}</div>
            </div>
        )
    }
}

Tip.defaultProps = {
  title: '',
};

Tip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any
  //   .oneOfType([
  //   PropTypes.element,
  //   PropTypes.string,
  //   PropTypes.array
  // ]),
};


export default Tip


// WEBPACK FOOTER //
// ./src/components/search/FormElements/Tip/Tip.js